"use client";
import styles from "./PageHeader.module.scss";
import { usePathname, useRouter } from "next/navigation";
import { QuickLinksData } from "../constants";
import { Images } from "@/utils/imageRelativePaths";
import Image from "next/image";
export default function AstroPageHeader({
  content,
  showHeader,
  showPath = true,
}: {
  content?: React.ReactNode;
  showHeader?: boolean;
  showPath?: boolean;
}): JSX.Element {
  const pathName = usePathname();
  const router = useRouter();
  const pagePath = showHeader ? "" : pathName.split("/")[1];
  const pageData = QuickLinksData.find((item) => item.link === pagePath);

  return (
    <div className={styles.pageHeader}>
      {showPath && (
        <div className={styles.pathBar}>
          <div className={styles.pathNameCont}>
            <span onClick={() => router.push("/")}>Home</span>
            <span onClick={() => router.push(`/${pageData?.link ?? "/"}`)}>
              {" "}
              / {pageData?.title}{" "}
            </span>
          </div>
        </div>
      )}
      {pageData ? (
        <div
          className={styles.header}
          style={{ borderImage: `${pageData.gradient} fill 1` }}
        >
          <Image
            src={pageData.background}
            alt={"background"}
            className={styles["background"]}
          />
          <div className={styles.headerCont}>
            <div className={styles.content}>
              <div
                className={styles["gradient_back"]}
                style={{ background: pageData.gradient }}
              ></div>
              <Image
                onClick={() => router.back()}
                src={Images.arrow_left}
                className={styles.back}
                alt={"left"}
                width={53}
                height={53}
              />
              {pageData?.icon && <Image src={pageData.icon} alt={"icon"} />}
              {pathName?.includes("compatibility/zodiac/") ? (
                <h2>compatibility / zodiac / result</h2>
              ) : (
                <h2>
                  {pageData.title ||
                    pathName?.split("/")?.slice(1)?.join(" / ")}
                </h2>
              )}
            </div>
            <div className={styles.contentContainer}>{content}</div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
